<template>
  <div class="integrations-list">
    <template v-if="integrations && integrations.length">
      <VacancyIntegrationsListItem

        v-for="(integration,index) in integrations"
        :key="index"
        :integration="integration"
      />
    </template>
    <IntegrationsListEmpty v-else />
  </div>
</template>

<script>
import VacancyIntegrationsListItem from '@/components/Integrations/IntegrationsListItem';
import useIntegrationVacancy from '@/compositions/useIntegrationVacancy';
import { computed, ref } from '@vue/composition-api';
import useIntegrations from '@/compositions/useIntegrations';
import IntegrationsListEmpty from '@/components/Integrations/IntegrationsListEmpty';

export default {
  name: 'IntegrationsList',
  components: {
    IntegrationsListEmpty,
    VacancyIntegrationsListItem,
  },
  setup() {
    const { externalVacancies } = useIntegrationVacancy();
    const { integrations } = useIntegrations();
    const linkedVacancies = ref([]);
    const showVacancyListDialog = ref(false);
    const activeIntegration = ref(null);
    const showDialog = ref(false);
    const disableDialog = ref(false);

    function onLink(val) {
      linkedVacancies.value = val;
      showVacancyListDialog.value = true;
    }
    function save() {
      showVacancyListDialog.value = false;
    }

    return {
      integrations,
      externalVacancies,
      vacancies: computed(() => {
        return this.externalVacancies.filter((v) => !linkedVacancies.some((l) => l.external_id === v.external_id));
      }),
      onLink,
      save,
      disableDialog,
      showDialog,
      activeIntegration,
      showVacancyListDialog,
    };
  },
};
</script>

<style scoped>
.integrations-list {
  padding-top: 40px;
}
</style>

<i18n lang="yml" locale="en">
  import: Jobs import
</i18n>
<i18n lang="yml" locale="ru">
  import: Импорт вакансий
  importDescription: 'Эти вакансии есть на Rabota.ru, но в Huntica их, вероятно, нет.
  Выберите вакансии, которые вы хотите импортировать в Huntica для получения видеооткликов'
</i18n>
